import { c as _c } from "react/compiler-runtime";
import { ActionMenu, ActionMenuItem, ActionMenuItemProps } from '@systemeio/ui';
import { XCircleIcon } from '@systemeio/ui/icons';
import { ReactNode } from 'react';
import ItemCount from 'shared/components/item-count';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
export interface NotificationItemViewProps {
  isRead?: boolean;
  icon?: ReactNode;
  message: string;
  description?: ReactNode;
  showCancelButton?: boolean;
  isCancelling?: boolean;
  actions?: ActionMenuItemProps[];
  onClick?: () => void;
  onCancel?: () => void;
}
export const NotificationItemView = t0 => {
  const $ = _c(26);
  const {
    isRead,
    icon,
    message,
    description,
    showCancelButton,
    isCancelling,
    actions,
    onClick,
    onCancel
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const isActions = actions && actions.length > 0;
  const t1 = isRead && "text-text-secondary group-hover:text-text-primary";
  const t2 = onClick && "cursor-pointer";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = twMerge("bg-background-secondary border-text-secondary text-text-primary hover:bg-brand-primary-subtle group flex flex-row justify-between border-b px-6 py-4 transition last:border-b-0", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== message) {
    t4 = <div><span className="group-hover:text-text-primary transition" dangerouslySetInnerHTML={{
        __html: message
      }} /></div>;
    $[3] = message;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description || $[6] !== t4) {
    t5 = <div className="text-start mr-auto w-full">{t4}{description}</div>;
    $[5] = description;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isCancelling || $[9] !== onCancel || $[10] !== showCancelButton) {
    t6 = showCancelButton && <button className={twMerge("group/cancel", isCancelling && "animate-pulse cursor-progress")} disabled={isCancelling} onClick={event => {
      event.stopPropagation();
      onCancel?.();
    }}><XCircleIcon className="group-hover/cancel:[&>path]:fill-brand-primary [&>path]:main-transition-colors h-5 w-5" /></button>;
    $[8] = isCancelling;
    $[9] = onCancel;
    $[10] = showCancelButton;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== icon || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className="inline-flex w-full flex-row items-center gap-4">{icon}{t5}{t6}</div>;
    $[12] = icon;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== actions || $[17] !== isActions || $[18] !== isRead || $[19] !== t) {
    t8 = (!isRead || isActions) && <div className="inline-flex flex-row items-center gap-4 pl-3">{!isRead && <ItemCount>{t("dashboard.notifications.new")}</ItemCount>}{isActions && <ActionMenu menuItems={actions.map(_temp)} />}</div>;
    $[16] = actions;
    $[17] = isActions;
    $[18] = isRead;
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== onClick || $[22] !== t3 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={t3} onClick={onClick}>{t7}{t8}</div>;
    $[21] = onClick;
    $[22] = t3;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
function _temp(action) {
  return <ActionMenuItem key={`${action.label}-na-action`} label={action.label} onClick={action.onClick} />;
}